export const Actions = {
    SET_PRODUCT: 'SET_PRODUCT',
    ADD_PRODUCT: 'ADD_PRODUCT',
    REMOVE_PRODUCT: 'REMOVE_PRODUCT',
    UPDATE_PRODUCT: 'UPDATE_PRODUCT',
};
